// extracted by mini-css-extract-plugin
export default {"title":"title-xGj2H"};